import styled from "styled-components";

export const Wrapper = styled.div`
  padding: 20px 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  border-radius: 10px;
  border: 1px solid hsla(245, 60%, 96%, 1);

  & svg {
    min-width: 24px;
    min-height: 24px;
    color: ${(props) => props.theme.palette.secondary.orange500};
  }
`;

export const Title = styled.p`
  font-family: "Mulish";
  font-weight: 400;
  font-size: ${16 / 16}rem;
  margin-top: 20px;
  color: ${(props) => props.theme.palette.black.default};
`;
